import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePassOns } from '../hooks/useFirestore';
import LatestPassOn from '../components/LatestPassOn';
import History from '../components/History';
import LoadingSpinner from '../components/LoadingSpinner';
import '../styles/Home.css';

const Home = () => {
  const { passOns, loading: isLoading } = usePassOns({ isActive: true });
  const location = useLocation();
  
  // Get the latest pass-on (most recent) and previous one
  const latestPassOn = passOns.length > 0 ? passOns[0] : null;
  const previousPassOn = passOns.length > 1 ? passOns[1] : null;

  // Check if user just posted something (coming from pass-on page)
  useEffect(() => {
    if (location.state?.message) {
      // Clear the location state so messages don't show on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  if (isLoading) {
    return (
      <div className="home-page">
        <div className="home-container">
          <LoadingSpinner message="Loading pass-ons..." />
        </div>
      </div>
    );
  }

  return (
    <div className="home-page">
      <div className="home-container">
        
        <header className="home-header">
          <h1>Give It To Next Person</h1>
          <p className="home-tagline">
            Pass on your thoughts, images, and messages to the next person in the chain
          </p>
        </header>

        <main className="home-main">
          <LatestPassOn passOn={latestPassOn} previousPassOn={previousPassOn} />
          
          <div className="pass-on-cta">
          <p>Reply to {latestPassOn?.title || latestPassOn?.name || 'Anonymous'}</p>
          <div
        
        style={{
          marginTop: '1rem'
        }}
          ></div>
            <a href="/pass-on" className="cta-button">
              Reply
            </a>
          </div>

          <History 
            passOns={passOns} 
            isLoading={isLoading}
          />

          <div className="social-sharing">
            <p className="social-text">Share your creation & see what others did!</p>
            <div className="social-buttons">
              <button className="social-btn tiktok" aria-label="Share on TikTok">
                <span>TikTok</span>
              </button>
              <button className="social-btn instagram" aria-label="Share on Instagram">
                <span>Instagram</span>
              </button>
              <button className="social-btn discord" aria-label="Share on Discord">
                <span>Discord</span>
              </button>
              <button className="social-btn twitter" aria-label="Share on Twitter">
                <span>Twitter</span>
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Home;